module.exports = __webpack_public_path__ + "img/hongbao.c6eaa3d9.png";